/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentsRequestPaymentDto } from '../../models/contents-request-payment-dto';

export interface ContentsRequestPaymentControllerFindByContentsRequestId$Params {
  id: string;
}

export function contentsRequestPaymentControllerFindByContentsRequestId(http: HttpClient, rootUrl: string, params: ContentsRequestPaymentControllerFindByContentsRequestId$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestPaymentDto>> {
  const rb = new RequestBuilder(rootUrl, contentsRequestPaymentControllerFindByContentsRequestId.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentsRequestPaymentDto>;
    })
  );
}

contentsRequestPaymentControllerFindByContentsRequestId.PATH = '/api/contents-request-payment/{id}/contentsRequest';
